export class NetworkResource {
  id: number;
  organization_id: number;

  network: string;
  type: string;

  name: string;
  external_id: string;

  child_ids: number[];
  parent_ids: number[];

  is_active: boolean;

  // Read-only: true when the backend has stored credentials for this resource.
  has_credentials: boolean;

  // Write-only: tokens entered by the user during create/update. Never present on responses.
  auth_keys?: Record<string, any>;

  metadata: Record<string, any>;

  constructor() {
    this.id = -1;
    this.organization_id = -1;

    this.network = "";
    this.type = "";

    this.name = "";
    this.external_id = "";

    this.child_ids = [];
    this.parent_ids = [];

    this.is_active = true;

    this.has_credentials = false;

    this.metadata = {};
  }
}
